import { render, staticRenderFns } from "./smsInquiry.vue?vue&type=template&id=8b1c03ae&scoped=true"
import script from "./smsInquiry.vue?vue&type=script&lang=js"
export * from "./smsInquiry.vue?vue&type=script&lang=js"
import style0 from "./smsInquiry.vue?vue&type=style&index=0&id=8b1c03ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1c03ae",
  null
  
)

export default component.exports